

import React from 'react';
import Speech from 'react-speech';
import { Link } from "react-router-dom";

// Components 
import Menu from '../components/menu';
import { Helmet } from 'react-helmet';
// import weinacht_image2 from "../css/image/weinachten2.jpg";


class Start extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        window.scrollTo(0, 0)
        return (<>

            <Helmet>
                {/* Grundlegende Meta-Tags */}
                <meta charSet="utf-8" />
                <title>Lebenshilfe Rinteln</title>
                <meta name="description" content="Lebenshilfe Rinteln e.V. ist eine Einrichtung zur Betreuung und Förderung von Menschen mit speziellen Bedürfnissen." />
                <meta name="keywords" content="Lebenshilfe Rinteln, Lebenshilfe, Rinteln" />
                <meta name="author" content="Lebenshilfe-Rinteln" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

                {/* Canonical Link */}
                <link rel="canonical" href="https://www.lebenshilfe-rinteln.de" />
            </Helmet>



            <div className="animate__animated animate__fadeIn" style={{ overflowX: "hidden" }}>

                <video className="start-video" autoPlay muted loop playsInline>
                    <source src="/video1.mp4" type="video/mp4" />
                    Dein Browser unterstützt das Video-Tag nicht.
                </video>



                <div className='start-menu'>
                    <Menu {...this.props} />
                </div>



                {/*      <div className="pt-5 pb-5 weinachtsDiv">
                    <div className="container pt-5 pb-5">
                        <img src={weinacht_image2} className="rounded" alt="" width={"100%"} height="auto" style={{ objectFit: "cover" }} />
                    </div>
                </div> */}



                {/*  <>
                <div className="pt-5 pb-5 weinachtsDiv">

                <div className="container pt-5 pb-5">
                
                <div className="row m-0">
                
                <div className="col-12 col-md-6">
                <img src={weinacht_image} className="rounded" alt="" width={"100%"} height="300px" style={{ objectFit: "cover" }} />
                </div>
                
                <div className="col-12 col-md-6 m-auto ff-3 winachtstext">
                <p>Wir wünschen allen einen besinnlichen Advent, eine frohe Weihnachtszeit und alles Gute für das neue Jahr!</p>
                </div>
                
                </div>
                    </div>
                    </div>
            </> */}

                <>
                    {/* Eyecatcher – Neu bei der Lebenshilfe */}
                    <div className="container my-5">
                        <div className="text-center mb-4">
                            <span className="eyecatcher-label d-inline-block px-4 py-2 rounded-pill text-white font-weight-bold shadow-sm" style={{
                                background: "linear-gradient(135deg, #0b739c, #14a3a8)",
                                fontSize: "0.85rem",
                                letterSpacing: "2px",
                                textTransform: "uppercase",
                                animation: "eyecatcherPulse 2.5s ease-in-out infinite"
                            }}>
                                ★ Neu bei der Lebenshilfe ★
                            </span>
                            <h2 className="mt-3 mb-1 font-weight-bold ff-1" style={{ color: "#2c3e50", fontSize: "1.8rem" }}>
                                Unser Angebot wächst!
                            </h2>
                            <p className="text-muted mb-0" style={{ fontSize: "1.05rem" }}>
                                Wir freuen uns, Ihnen zwei neue Bereiche vorzustellen.
                            </p>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {/* SPFH Card */}
                            <div className="col-md-6 mt-2">
                                <Link to="/spfh" className="text-decoration-none" style={{ textDecoration: "none" }}>
                                    <div className="eyecatcher-card h-100 rounded shadow position-relative overflow-hidden" style={{
                                        background: "linear-gradient(160deg, #ffffff 0%, #fff5f5 100%)",
                                        border: "1px solid rgba(220,53,69,0.15)",
                                        cursor: "pointer"
                                    }}>
                                        <div className="position-absolute" style={{
                                            top: 0, right: 0, width: "120px", height: "120px",
                                            background: "linear-gradient(135deg, transparent 50%, rgba(220,53,69,0.08) 50%)"
                                        }}></div>
                                        <div className="p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{
                                                    width: "50px", height: "50px",
                                                    background: "linear-gradient(135deg, #dc3545, #a71d2a)",
                                                    flexShrink: 0
                                                }}>
                                                    <span style={{ fontSize: "1.4rem" }}>👨‍👩‍👧</span>
                                                </div>
                                                <div className="ml-3">
                                                    <span className="badge rounded-pill text-white px-3 py-1 mb-1" style={{
                                                        background: "linear-gradient(135deg, #dc3545, #c82333)",
                                                        fontSize: "0.7rem"
                                                    }}>Ab Mai 2026</span>
                                                    <h5 className="m-0 mt-1 font-weight-bold" style={{ color: "#2c3e50" }}>
                                                        Sozialpädagogische Familienhilfe
                                                    </h5>
                                                </div>
                                            </div>
                                            <p className="text-secondary mb-3" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                                                Ambulante Hilfe zur Erziehung – wir begleiten Familien in Alltagssituationen direkt bei Ihnen Zuhause.
                                            </p>
                                            <span className="font-weight-bold d-inline-flex align-items-center" style={{ color: "#dc3545", fontSize: "0.9rem" }}>
                                                Mehr erfahren <span className="ml-2" style={{ transition: "transform 0.2s" }}>→</span>
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            {/* ZARi Card */}
                            <div className="col-md-6 mt-2">
                                <Link to="/zari" className="text-decoration-none" style={{ textDecoration: "none" }}>
                                    <div className="eyecatcher-card h-100 rounded shadow position-relative overflow-hidden" style={{
                                        background: "linear-gradient(160deg, #ffffff 0%, #f0fafa 100%)",
                                        border: "1px solid rgba(13,115,119,0.15)",
                                        cursor: "pointer"
                                    }}>
                                        <div className="position-absolute" style={{
                                            top: 0, right: 0, width: "120px", height: "120px",
                                            background: "linear-gradient(135deg, transparent 50%, rgba(13,115,119,0.08) 50%)"
                                        }}></div>
                                        <div className="p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm" style={{
                                                    width: "50px", height: "50px",
                                                    background: "linear-gradient(135deg, #0d7377, #14a3a8)",
                                                    flexShrink: 0
                                                }}>
                                                    <span style={{ fontSize: "1.4rem" }}>🧩</span>
                                                </div>
                                                <div className="ml-3">
                                                    <span className="badge rounded-pill text-white px-3 py-1 mb-1" style={{
                                                        background: "linear-gradient(135deg, #0d7377, #14a3a8)",
                                                        fontSize: "0.7rem"
                                                    }}>Eröffnung 2026</span>
                                                    <h5 className="m-0 mt-1 font-weight-bold" style={{ color: "#2c3e50" }}>
                                                        ZARi – Zentrum für Autismus Rinteln
                                                    </h5>
                                                </div>
                                            </div>
                                            <p className="text-secondary mb-3" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                                                Heilpädagogische Intervention für Menschen im Autismus-Spektrum und Beratung für Angehörige.
                                            </p>
                                            <span className="font-weight-bold d-inline-flex align-items-center" style={{ color: "#0d7377", fontSize: "0.9rem" }}>
                                                Mehr erfahren <span className="ml-2" style={{ transition: "transform 0.2s" }}>→</span>
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Eyecatcher Styles */}
                    <style dangerouslySetInnerHTML={{ __html: `
                        @keyframes eyecatcherPulse {
                            0%, 100% { transform: scale(1); box-shadow: 0 2px 8px rgba(11,115,156,0.2); }
                            50% { transform: scale(1.03); box-shadow: 0 4px 20px rgba(11,115,156,0.35); }
                        }
                        .eyecatcher-card {
                            transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                        }
                        .eyecatcher-card:hover {
                            transform: translateY(-6px);
                            box-shadow: 0 1.2rem 2.5rem rgba(0,0,0,0.12) !important;
                        }
                        .eyecatcher-card:hover span:last-child span {
                            transform: translateX(5px);
                        }
                    `}} />
                </>







                <>
                    <div className="ff-3" style={{ color: "#3364a0" }}>
                        <div className="block-small text-center m-0">
                            <h3 className="m-auto bg-white p-3 rounded shadow-sm">Mit-Menschen... Für Menschen</h3>
                        </div>
                    </div>
                </>

                <div className='container mb-3'>

                    <div className='row m-0'>
                        <div className='col-12 col-lg-6 p-4 row'>
                            <div className="p-3 shadow-sm bg-white text-dark startText mt-2 rounded">
                                <p className="container">
                                    Lebenshilfe Rinteln e.V. ist eine Einrichtung zur Betreuung und Förderung von Menschen mit speziellen Bedürfnissen.
                                    Es gibt uns seit 1966. Unsere Anfänge waren in angemieteten Räumen in der Altstadt von Rinteln. 1998 zogen wir von der Ostertorstraße in die Waldkaterallee auf das Gelände des ehem.
                                    Britischen Militär Hospitals. Auf Grund der Möglichkeiten auf dem Gelände konnten wir weiter expandieren und neben der Platzzahlerhöhung von Frühförderung,
                                    Heilpädagogischen Kindergarten und Tagesbildungsstätte auch drei Wohnheime (alles Einrichtungen speziell für Menschen mit Beeinträchtigungen) in Betrieb nehmen.
                                    Am 01.09.2006 wurde der von der Heimaufsicht genehmigte Wohnbereich für Senioren mit geistiger Beeinträchtigung mit 24 Plätzen in Betrieb genommen.
                                    Am 01.09.2015 hat unser Pflegeheim "Haus am Waldkater" seinen Betrieb aufgenommen und schon nach kurzer Zeit eine sehr gute Auslastung erreicht.
                                    Am 01.09.2016 wurde der Regelkindergarten Integrative "Kindertagesstätte am Waldkater" eröffnet und im Jahr 2019 um eine Krippen- sowie die Integrationsgruppe erweitert.
                                    Im Jahr 2021 erfolgte der Umzug des Seniorenwohnens in das frisch umgebaute Haus Antonia. Seit 2024 bieten wir mit unserem Projekt
                                    „Stallpiraten“ den hier betreuten Menschen (pädagogisch) begleitete Interaktion mit unseren Tieren (zur Zeit Pferde, Ponys, Esel) an.
                                    Die therapeutische Begleitung unserer Bewohner und Klienten im Bereich Physio-, Ergo- und Logopädie erfolgt mittlerweile hausintern durch unser
                                    „Therapiezentrum am Waldkater“.  Im Mai 2025 hat unser neuer Bereich „Tagespflege am Waldkater“ eröffnet. Die Tagespflege ist ein Angebot für Menschen im Seniorenalter,
                                    die noch im häuslichen Umfeld wohnen und tagsüber Betreuung benötigen. Heute werden bei uns ca. 600 Menschen in den verschiedenen Bereichen gefördert und betreut.
                                </p>

                                {this.props.mobileVersion ? "" :
                                    <div className="d-flex mt-3 mb-3">
                                        <div className="ml-auto mr-auto sprechen d-flex border p-2 rounded bg-secondary text-center">
                                            <Speech
                                                lang="de"
                                                displayText="Vorlesen"
                                                stop
                                                rate={0.8}
                                                text={`
                                                       Lebenshilfe Rinteln e.V. ist eine Einrichtung zur Betreuung und Förderung von Menschen mit speziellen Bedürfnissen.
                                    Es gibt uns seit 1966. Unsere Anfänge waren in angemieteten Räumen in der Altstadt von Rinteln. 1998 zogen wir von der Ostertorstraße in die Waldkaterallee auf das Gelände des ehem.
                                    Britischen Militär Hospitals. Auf Grund der Möglichkeiten auf dem Gelände konnten wir weiter expandieren und neben der Platzzahlerhöhung von Frühförderung,
                                    Heilpädagogischen Kindergarten und Tagesbildungsstätte auch drei Wohnheime (alles Einrichtungen speziell für Menschen mit Beeinträchtigungen) in Betrieb nehmen.
                                    Am 01.09.2006 wurde der von der Heimaufsicht genehmigte Wohnbereich für Senioren mit geistiger Beeinträchtigung mit 24 Plätzen in Betrieb genommen.
                                    Am 01.09.2015 hat unser Pflegeheim "Haus am Waldkater" seinen Betrieb aufgenommen und schon nach kurzer Zeit eine sehr gute Auslastung erreicht.
                                    Am 01.09.2016 wurde der Regelkindergarten Integrative "Kindertagesstätte am Waldkater" eröffnet und im Jahr 2019 um eine Krippen- sowie die Integrationsgruppe erweitert.
                                    Im Jahr 2021 erfolgte der Umzug des Seniorenwohnens in das frisch umgebaute Haus Antonia. Seit 2024 bieten wir mit unserem Projekt
                                    „Stallpiraten“ den hier betreuten Menschen (pädagogisch) begleitete Interaktion mit unseren Tieren (zur Zeit Pferde, Ponys, Esel) an.
                                    Die therapeutische Begleitung unserer Bewohner und Klienten im Bereich Physio-, Ergo- und Logopädie erfolgt mittlerweile hausintern durch unser
                                    „Therapiezentrum am Waldkater“.  Im Mai 2025 hat unser neuer Bereich „Tagespflege am Waldkater“ eröffnet. Die Tagespflege ist ein Angebot für Menschen im Seniorenalter,
                                    die noch im häuslichen Umfeld wohnen und tagsüber Betreuung benötigen. Heute werden bei uns ca. 600 Menschen in den verschiedenen Bereichen gefördert und betreut.
                                `}
                                            />
                                            <span className="mt-2 ml-1 text-white">Vorlesen</span>

                                        </div>

                                    </div>
                                }
                            </div>
                        </div>


                        <div className='col-12 col-lg-6 p-4 row'>
                            <div className="col-12 shadow-sm bg-white text-dark mt-2 pb-2 rounded d-flex flex-column justify-content-center">
                                <p className="mt-2">Lebenshilfe Rinteln Imagefilm</p>
                                <video style={{ width: "100%", borderRadius: "10px" }} controls poster="poster1.png" >
                                    <source src="/video1.mp4" type="video/mp4" />
                                    Dein Browser unterstützt das Video-Tag nicht.
                                </video>
                            </div>

                            <div className="col-12 shadow-sm bg-white text-dark mt-2 pb-2 rounded d-flex flex-column justify-content-center">
                                <p className="mt-2">Lebenshilfe Rinteln Kinospot</p>
                                <video style={{ width: "100%", borderRadius: "10px" }} controls poster='poster2.png' >
                                    <source src="/video2.mp4" type="video/mp4" />
                                    Dein Browser unterstützt das Video-Tag nicht.
                                </video>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </>
        );
    }
}

export default Start;